<template>
  <p-input-number
    ref="currencyInput"
    v-model="currencyValue"
    :max-fraction-digits="2"
    mode="currency"
    currency="USD"
    locale="en-US"
    fluid
    @keyup.enter="$emit('enter', currencyValue)"
    @blur="emitBlur"
  ></p-input-number>
</template>

<script setup>
import { nextTick } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  autofocus: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'leave'])

const currencyValue = computed({
  get () {
    if (props.modelValue && typeof props.modelValue === 'string') {
      return parseFloat(props.modelValue)
    }
    return props.modelValue
  },
  set (v) {
    emit('update:modelValue', v)
  }
})

const emitBlur = (event) => {
  // For madlibs - when clicking out of this pv currency input, the currencyValue change was happening AFTER the blur event
  // This is to keep the order of first updating the value, then emitting blur

  // Update: after removing compat layer, the blur event was bubbling and closing the madlib
  // input re-introducing this behavior. Renaming blur to leave to address the issue.
  nextTick(() => emit('leave', event))
}
</script>
